module.exports = __webpack_public_path__ + "img/22.490bc08a.gif";